/*
 *
 * Package: `@dbh/form-section-theme`.
 *
 */const THEME_KEY_FORM_SECTION="formSection";const modifyFormSectionTheme=a=>{let{colors:{brandFirst:b,transparent:c,greyLight:d,greyMid:e,greyUltralight:f,blackMid:g},spacing:{sp3:h,sp5:i},fonts:{size:{ff6:j,ff8:k}}}=a;return {[THEME_KEY_FORM_SECTION]:{titleSize:j,titleColor:g,titleLineHeight:"unset",titleWrapperMarginBottom:i,descriptionSize:k,padding:h,margin:"0 0 "+h,backgroundColor:f,borderBottom:{left:0,right:0,size:"0.2rem",color:e},valid:{// Until specifications are provided, we do not show a border, when valid.
borderColor:c},warning:{borderColor:d},error:{borderColor:b},untouched:{borderColor:c}}}};

export { THEME_KEY_FORM_SECTION, modifyFormSectionTheme as default };
